// GENERATED by lead1-crm-cloud-functions scripts/buildRuntimeAssets.js — DO NOT EDIT.
// Edit the sources under functions/landingPages/runtime/ and re-run npm run build:runtime-assets.
// Landing runtime i18n. CJS on purpose: consumed by Cloud Functions, the
// asset build script, and (copied verbatim) by the CRM via webpack interop.
const DICTIONARIES = {
  en: {
    microcopy: {
      sending: 'Sending…',
      errorGeneric: 'Something went wrong. Please try again.',
      errorPhone: 'Enter a valid phone number.',
      errorEmail: 'Enter a valid email address.',
      errorRequired: 'This field is required.',
      errorConsentRequired: 'This consent is required.',
      galleryLabel: 'Image gallery',
      galleryRoleDescription: 'carousel',
      galleryPrev: 'Previous image',
      galleryNext: 'Next image',
      galleryZoom: 'Enlarge image',
      galleryClose: 'Close',
    },
    consents: {
      // Nessun link nel default: l'informativa cambia da cliente a cliente e
      // un URL precompilato passerebbe la validazione sembrando già a posto.
      // Il link va aggiunto dall'operatore ed è obbligatorio in pubblicazione.
      privacyNoteText: 'By submitting or calling you accept our',
      byName: {
        marketingConsent:
          'I consent to the processing of my data for marketing activities.',
        thirdPartyConsent:
          'I consent to the processing of my data for communication to third parties for their marketing activities.',
        profilingConsent: '',
        customerConsent: '',
        customerConsentProfile: '',
      },
    },
    fields: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      zipCode: 'ZIP Code',
      birthday: 'Date of birth',
    },
    componentDefaults: {
      lead_form: {
        buttonLabel: 'Send',
        successMessage: 'Thank you! We will contact you soon.',
      },
      callback_or_call: {
        choiceTitle: 'How do you prefer to be contacted?',
        callbackButtonLabel: 'I want to be contacted',
        callButtonLabel: 'I prefer to call directly',
        backLabel: 'Go back',
        successMessage: 'Thank you! We will contact you soon.',
      },
      click_to_call: {
        title: 'Call us now',
        buttonLabel: 'Call now',
      },
    },
  },
  it: {
    microcopy: {
      sending: 'Invio in corso…',
      errorGeneric: 'Qualcosa è andato storto. Riprova.',
      errorPhone: 'Inserisci un numero di telefono valido.',
      errorEmail: 'Inserisci un indirizzo email valido.',
      errorRequired: 'Campo obbligatorio.',
      errorConsentRequired: 'Consenso obbligatorio.',
      galleryLabel: 'Galleria immagini',
      galleryRoleDescription: 'carosello',
      galleryPrev: 'Immagine precedente',
      galleryNext: 'Immagine successiva',
      galleryZoom: 'Ingrandisci immagine',
      galleryClose: 'Chiudi',
    },
    consents: {
      privacyNoteText: 'Inviando la richiesta o chiamando accetti la nostra',
      byName: {
        marketingConsent:
          'Acconsento al trattamento dei miei dati per attività di marketing.',
        thirdPartyConsent:
          'Acconsento alla comunicazione dei miei dati a terzi per le loro attività di marketing.',
        profilingConsent: '',
        customerConsent: '',
        customerConsentProfile: '',
      },
    },
    fields: {
      firstName: 'Nome',
      lastName: 'Cognome',
      email: 'Email',
      phone: 'Telefono',
      zipCode: 'CAP',
      birthday: 'Data di nascita',
    },
    componentDefaults: {
      lead_form: {
        buttonLabel: 'Invia la richiesta',
        successMessage: 'Grazie! Ti ricontatteremo al più presto.',
      },
      callback_or_call: {
        choiceTitle: 'Come preferisci essere contattato?',
        callbackButtonLabel: 'Voglio essere ricontattato',
        callButtonLabel: 'Preferisco chiamare subito',
        backLabel: 'Torna indietro',
        successMessage: 'Grazie! Ti ricontatteremo al più presto.',
      },
      click_to_call: {
        title: 'Chiamaci ora',
        buttonLabel: 'Chiama ora',
      },
    },
  },
  es: {
    microcopy: {
      sending: 'Enviando…',
      errorGeneric: 'Algo ha salido mal. Inténtalo de nuevo.',
      errorPhone: 'Introduce un número de teléfono válido.',
      errorEmail: 'Introduce una dirección de email válida.',
      errorRequired: 'Campo obligatorio.',
      errorConsentRequired: 'Consentimiento obligatorio.',
      galleryLabel: 'Galería de imágenes',
      galleryRoleDescription: 'carrusel',
      galleryPrev: 'Imagen anterior',
      galleryNext: 'Imagen siguiente',
      galleryZoom: 'Ampliar imagen',
      galleryClose: 'Cerrar',
    },
    consents: {
      privacyNoteText: 'Al enviar la solicitud o llamar aceptas nuestra',
      byName: {
        marketingConsent:
          'Doy mi consentimiento al tratamiento de mis datos para actividades de marketing.',
        thirdPartyConsent:
          'Doy mi consentimiento a la comunicación de mis datos a terceros para sus actividades de marketing.',
        profilingConsent: '',
        customerConsent: '',
        customerConsentProfile: '',
      },
    },
    fields: {
      firstName: 'Nombre',
      lastName: 'Apellidos',
      email: 'Email',
      phone: 'Teléfono',
      zipCode: 'Código postal',
      birthday: 'Fecha de nacimiento',
    },
    componentDefaults: {
      lead_form: {
        buttonLabel: 'Enviar solicitud',
        successMessage: '¡Gracias! Te contactaremos lo antes posible.',
      },
      callback_or_call: {
        choiceTitle: '¿Cómo prefieres que te contactemos?',
        callbackButtonLabel: 'Quiero que me llamen',
        callButtonLabel: 'Prefiero llamar ahora',
        backLabel: 'Volver',
        successMessage: '¡Gracias! Te contactaremos lo antes posible.',
      },
      click_to_call: {
        title: 'Llámanos ahora',
        buttonLabel: 'Llamar ahora',
      },
    },
  },
};

const resolveLanguage = (tag) => {
  const value = String(tag || '').trim();
  if (DICTIONARIES[value]) return value;
  const base = value.toLowerCase().split('-')[0];
  if (DICTIONARIES[base]) return base;
  return 'en';
};

const getMicrocopy = (tag) => DICTIONARIES[resolveLanguage(tag)].microcopy;

const getConsentDefaults = (tag) => DICTIONARIES[resolveLanguage(tag)].consents;

const getFieldLabels = (tag) => DICTIONARIES[resolveLanguage(tag)].fields;

const getComponentDefaults = (tag) =>
  DICTIONARIES[resolveLanguage(tag)].componentDefaults;

module.exports = {
  DICTIONARIES,
  resolveLanguage,
  getMicrocopy,
  getConsentDefaults,
  getFieldLabels,
  getComponentDefaults,
};
